import { FaCalculator, FaCalendarCheck, FaCreditCard, FaRegClock, FaTruck } from 'react-icons/fa';
import { LiaPalletSolid } from 'react-icons/lia';
import {
  MdDescription,
  MdCheck,
  MdReceipt,
  MdTransform,
  MdEdit,
  MdWarning,
  MdChat,
  MdLink,
  MdLinkOff,
  MdPieChart,
  MdDelete,
  MdLogout,
  MdFileDownload,
  MdFileUpload,
  MdOutlineReceiptLong,
  MdAdd,
  MdInfo,
  MdSchedule,
  MdLocalPrintshop,
  MdContentPasteOff,
  MdOutlineFolderOff,
  MdRequestQuote,
  MdBarChart,
} from 'react-icons/md';
import FreshProduceIcon from 'images/FreshProduce';
import InputsIcon from 'images/Inputs';
import { ButtonIcon } from 'generated/graphql';
import ProfileSwitch from './ProfileSwitch';

const BtnIcon = ({ icon, size }: { icon: ButtonIcon; size?: number }) => {
  switch (icon) {
    case ButtonIcon.Add:
      return <MdAdd size={size} />;
    case ButtonIcon.Chat:
      return <MdChat size={size} />;
    case ButtonIcon.Document:
      return <MdDescription size={size} />;
    case ButtonIcon.Checkmark:
      return <MdCheck size={size} />;
    case ButtonIcon.Transform:
      return <MdTransform size={size} />;
    case ButtonIcon.Receipt:
      return <MdReceipt size={size} />;
    case ButtonIcon.Card:
      return <FaCreditCard size={size} />;
    case ButtonIcon.Edit:
      return <MdEdit size={size} />;
    case ButtonIcon.UploadFile:
      return <MdFileUpload size={size} />;
    case ButtonIcon.DownloadFile:
      return <MdFileDownload size={size} />;
    case ButtonIcon.Truck:
      return <FaTruck size={size} />;
    case ButtonIcon.Warning:
      return <MdWarning size={size} />;
    case ButtonIcon.Link:
      return <MdLink size={size} />;
    case ButtonIcon.UnLink:
      return <MdLinkOff size={size} />;
    case ButtonIcon.PieChart:
      return <MdPieChart size={size} />;
    case ButtonIcon.Trash:
      return <MdDelete size={size} />;
    case ButtonIcon.Logout:
      return <MdLogout size={size} />;
    case ButtonIcon.Report:
      return <MdOutlineReceiptLong size={size} />;
    case ButtonIcon.Calculator:
      return <FaCalculator size={size} />;
    case ButtonIcon.ProfileSwitch:
      return <ProfileSwitch />;
    case ButtonIcon.FreshProduce:
      return <FreshProduceIcon width={size ?? 24} height={size ?? 24} />;
    case ButtonIcon.Inputs:
      return <InputsIcon width={size ?? 24} height={size ?? 24} />;
    case ButtonIcon.Chep:
      return <LiaPalletSolid size={size ?? 16} />;
    case ButtonIcon.Info:
      return <MdInfo size={size ?? 24} />;
    case ButtonIcon.Clock:
      return <FaRegClock size={size} />;
    case ButtonIcon.Print:
      return <MdLocalPrintshop size={size} />;
    case ButtonIcon.FolderOff:
      return <MdOutlineFolderOff size={size} />;
    case ButtonIcon.CalendarCheck:
      return <FaCalendarCheck size={size} />;
    case ButtonIcon.ClipboardOff:
      return <MdContentPasteOff size={size} />;
    case ButtonIcon.Quote:
      return <MdRequestQuote size={size} />;
    case ButtonIcon.BarChart:
      return <MdBarChart size={size} />;
    // case ButtonIcon.ChepLogo: // TODO - Bug fix: This should be used on profile switcher
    //   return <img src={ChepImage} width={76} height={21} alt="" />;
    default:
      return null;
  }
};

/**
 * The startIcon for a server-sent button: undefined for None, which the enum
 * carries for buttons that have no icon, so a Button asked to collapse stays
 * labelled rather than becoming an icon button with nothing in it.
 */
export const btnIconGlyph = (icon?: ButtonIcon) =>
  icon && icon !== ButtonIcon.None ? <BtnIcon icon={icon} /> : undefined;

export default BtnIcon;
